import * as React from 'react';
import logerxBackground from '../images/logerx_background.png';
import Page from './Page';

const Home = () => {
    return (
        <Page>

            <img className="img-responsive"
                src={ logerxBackground }
                style={{ width: "100%" }} />
                  
        </Page>
    );

};

export default Home;
